/**
 * Hook para manejar permisos de usuario en el módulo de Producción
 * Por ahora retorna permisos completos, pero se puede expandir para 
 * integrar con el sistema RBAC existente
 */
import { useApp } from '../../context/AppContext';

export const usePermissions = (tabla) => {
  const { user } = useApp();
  
  // Admin tiene todos los permisos
  const isAdmin = user?.rol === 'admin';
  
  // Por defecto, dar permisos completos al admin
  // Para otros roles, verificar permisos específicos
  if (isAdmin) {
    return {
      canCreate: true,
      canEdit: true,
      canDelete: true,
      canView: true,
      isReadOnly: false,
    };
  }
  
  // Rol de lectura
  if (user?.rol === 'lectura') {
    return {
      canCreate: false,
      canEdit: false,
      canDelete: false,
      canView: true,
      isReadOnly: true,
    };
  }
  
  // Usuario normal: verificar permisos específicos de la tabla
  // TODO: Integrar con endpoint /api/permisos para obtener permisos granulares
  return {
    canCreate: true,
    canEdit: true,
    canDelete: true,
    canView: true,
    isReadOnly: false,
  };
};

export default usePermissions;
